import "@/App.css";
import { useMod } from "@/lib/mod";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Kurulum from "@/pages/Kurulum";
import Dashboard from "@/pages/Dashboard";
import Urunler from "@/pages/Urunler";
import Receteler from "@/pages/Receteler";
import Lokasyonlar from "@/pages/Lokasyonlar";
import FiyatListeleri from "@/pages/FiyatListeleri";
import Varyantlar from "@/pages/Varyantlar";
import TopluGuncelleme from "@/pages/TopluGuncelleme";
import DepoSimulasyon from "@/pages/DepoSimulasyon";
import Istasyonlar from "@/pages/Istasyonlar";
import Ayarlar from "@/pages/Ayarlar";
import Cariler from "@/pages/Cariler";
import CariSayfa from "@/pages/CariSayfa";
import CariForm from "@/pages/CariForm";
import Siparisler from "@/pages/Siparisler";
import SatisBelgeYeni from "@/pages/SatisBelgeYeni";
import Depo from "@/pages/Depo";
import UretimPlani from "@/pages/UretimPlani";
import Islerim from "@/pages/Islerim";
import IsEmirleri from "@/pages/IsEmirleri";
import IstasyonEkrani from "@/pages/IstasyonEkrani";
import YazdirmaSablonlari from "@/pages/YazdirmaSablonlari";
import UretimRaporlari from "@/pages/UretimRaporlari";
import KalipTermin from "@/pages/KalipTermin";
import Tahsilatlar from "@/pages/Tahsilatlar";
import Sevkiyatlar from "@/pages/Sevkiyatlar";
import SatinAlma from "@/pages/SatinAlma";
import AlisFaturalari from "@/pages/AlisFaturalari";
import TedarikciOdemeleri from "@/pages/TedarikciOdemeleri";
import GunlukOzet from "@/pages/GunlukOzet";
import BankaHesaplari from "@/pages/BankaHesaplari";
import FinansHesaplar from "@/pages/FinansHesaplar";
import HesapDetay from "@/pages/HesapDetay";
import CekSenetler from "@/pages/CekSenetler";
import CekDetay from "@/pages/CekDetay";
import NakitAkis from "@/pages/NakitAkis";
import BankaMutabakat from "@/pages/BankaMutabakat";
import EDonusum from "@/pages/EDonusum";
import BankaAkis from "@/pages/BankaAkis";
import Aktarim from "@/pages/Aktarim";
import SaticiPaneli from "@/pages/SaticiPaneli";
import Yardim from "@/pages/Yardim";
import BayiPortal from "@/pages/BayiPortal";
import BayiBasvuru from "@/pages/BayiBasvuru";
import BayiBasvurulari from "@/pages/BayiBasvurulari";
import BayiDuyurulari from "@/pages/BayiDuyurulari";
import SiteYonetimi from "@/pages/SiteYonetimi";
import SiteLayout from "@/pages/site/SiteLayout";
import SiteAnasayfa from "@/pages/site/SiteAnasayfa";
import SiteUrunler from "@/pages/site/SiteUrunler";
import SiteUrunDetay from "@/pages/site/SiteUrunDetay";
import { SiteKurumsal, SiteKataloglar, SiteIletisim } from "@/pages/site/SiteSayfalar";
import { can } from "@/lib/perms";
import Giderler from "@/pages/Giderler";
import GiderDetay from "@/pages/GiderDetay";
import { GiderTipleri, TekrarliGiderler } from "@/pages/GiderAyarlari";
import Projeler, { ProjeDetay } from "@/pages/Projeler";
import Raporlar from "@/pages/Raporlar";
import Entegrasyonlar from "@/pages/Entegrasyonlar";
import Abonelik from "@/pages/Abonelik";
import Destek from "@/pages/Destek";
import EPostaAyarlari from "@/pages/EPostaAyarlari";
import SiparisSayfa from "@/pages/SiparisSayfa";
import SatisFaturaSayfa from "@/pages/SatisFaturaSayfa";
import Teklifler from "@/pages/Teklifler";
import TeklifSayfa from "@/pages/TeklifSayfa";
import TekrarliSatislar from "@/pages/TekrarliSatislar";
import TeklifOnay from "@/pages/TeklifOnay";
import MutabakatOnay from "@/pages/MutabakatOnay";
import Mutabakatlar from "@/pages/Mutabakatlar";
import UrunSayfa from "@/pages/UrunSayfa";
import Operasyonlar from "@/pages/Operasyonlar";
import SiparisAyarlari from "@/pages/SiparisAyarlari";

const Loading = () => (
  <div className="min-h-screen app-bg flex items-center justify-center text-muted-foreground text-sm" data-testid="app-loading">Yükleniyor…</div>
);

function Protected({ children, admin, perm }) {
  const { user, kurulum } = useAuth();
  if (user === null || !kurulum) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "bayi") return <Navigate to="/bayi" replace />;
  if (user.role === "istasyon") return <Navigate to="/istasyon" replace />;
  if (!kurulum.kurulum_tamam) return <Navigate to="/kurulum" replace />;
  if ((admin && user.role !== "admin") || (perm && !can(user, perm))) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function IstasyonGate() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!can(user, "uretim:islem")) return <Navigate to="/" replace />;
  return <IstasyonEkrani />;
}

function BayiGate() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "bayi") return <Navigate to="/" replace />;
  return <BayiPortal />;
}

function KurulumGate() {
  const { user, kurulum } = useAuth();
  if (user === null || !kurulum) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (kurulum.kurulum_tamam) return <Navigate to="/" replace />;
  return <Kurulum />;
}

const ModluToaster = () => <Toaster position="top-right" richColors theme={useMod() === "gunduz" ? "light" : "dark"} />;

function AnaSayfa() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/site/tr" replace />;
  return <Protected><Dashboard /></Protected>;
}


function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/giris" element={<Navigate to="/login" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/kurulum" element={<KurulumGate />} />
            <Route path="/site" element={<Navigate to="/site/tr" replace />} />
            <Route path="/site/:lang" element={<SiteLayout />}>
              <Route index element={<SiteAnasayfa />} />
              <Route path="urunler" element={<SiteUrunler />} />
              <Route path="urun/:kod" element={<SiteUrunDetay />} />
              <Route path="kurumsal" element={<SiteKurumsal />} />
              <Route path="kataloglar" element={<SiteKataloglar />} />
              <Route path="iletisim" element={<SiteIletisim />} />
              <Route path="*" element={<Navigate to=".." replace />} />
            </Route>
            <Route path="/site-yonetimi" element={<Protected admin><SiteYonetimi /></Protected>} />
            <Route path="/bayi" element={<BayiGate />} />
            <Route path="/bayi-basvuru" element={<BayiBasvuru />} />
            <Route path="/teklif/:token" element={<TeklifOnay />} />
            <Route path="/mutabakat/:token" element={<MutabakatOnay />} />
            <Route path="/bayi-basvurulari" element={<Protected perm="cari:write"><BayiBasvurulari /></Protected>} />
            <Route path="/bayi-duyurulari" element={<Protected perm="cari:write"><BayiDuyurulari /></Protected>} />
            <Route path="/cari-mutabakatlar" element={<Protected perm="cari:read"><Mutabakatlar /></Protected>} />
            <Route path="/" element={<AnaSayfa />} />
            <Route path="/urunler" element={<Protected><Urunler /></Protected>} />
            <Route path="/urun-listesi" element={<Protected><Urunler gorunum="urun" /></Protected>} />
            <Route path="/hizmetler" element={<Protected><Urunler gorunum="hizmet" /></Protected>} />
            <Route path="/fiyat-listeleri" element={<Protected><FiyatListeleri /></Protected>} />
            <Route path="/depo-simulasyon" element={<Protected perm="stok:read"><DepoSimulasyon /></Protected>} />
            <Route path="/varyantlar" element={<Protected><Varyantlar /></Protected>} />
            <Route path="/toplu-stok" element={<Protected perm="stok:write"><TopluGuncelleme tur="stok" /></Protected>} />
            <Route path="/toplu-urun" element={<Protected><TopluGuncelleme tur="urun" /></Protected>} />
            <Route path="/urunler/:id" element={<Protected><UrunSayfa /></Protected>} />
            <Route path="/operasyonlar" element={<Protected><Operasyonlar /></Protected>} />
            <Route path="/ayarlar/siparis" element={<Protected admin><SiparisAyarlari /></Protected>} />
            <Route path="/receteler" element={<Protected perm="recete:read"><Receteler /></Protected>} />
            <Route path="/cariler" element={<Protected perm="cari:read"><Cariler /></Protected>} />
            <Route path="/cariler/yeni" element={<Protected perm="cari:write"><CariForm /></Protected>} />
            <Route path="/cariler/:id" element={<Protected perm="cari:read"><CariSayfa /></Protected>} />
            <Route path="/cariler/:id/duzenle" element={<Protected perm="cari:write"><CariForm /></Protected>} />
            <Route path="/siparisler" element={<Protected perm="siparis:read"><Siparisler /></Protected>} />
            <Route path="/siparisler/yeni" element={<Protected perm="siparis:create"><SatisBelgeYeni tur="siparis" /></Protected>} />
            <Route path="/sevkiyat/yeni" element={<Protected perm="siparis:sevk"><SatisBelgeYeni tur="irsaliye" /></Protected>} />
            <Route path="/satis/teklifler/yeni" element={<Protected perm="siparis:create"><SatisBelgeYeni tur="teklif" /></Protected>} />
            <Route path="/siparisler/:id" element={<Protected perm="siparis:read"><SiparisSayfa /></Protected>} />
            <Route path="/depo" element={<Protected perm="stok:read"><Depo /></Protected>} />
            <Route path="/uretim" element={<Protected perm="uretim:read"><UretimPlani /></Protected>} />
            <Route path="/uretim-ihtiyaclari" element={<Navigate to="/uretim" replace />} />
            <Route path="/islerim" element={<Protected perm="uretim:islem"><Islerim /></Protected>} />
            <Route path="/istasyon" element={<IstasyonGate />} />
            <Route path="/is-emirleri" element={<Protected perm="uretim:read"><IsEmirleri /></Protected>} />
            <Route path="/uretim/raporlar" element={<Protected perm="uretim:plan"><UretimRaporlari /></Protected>} />
            <Route path="/uretim/kalip-kapasite" element={<Protected perm="uretim:read"><KalipTermin /></Protected>} />
            <Route path="/tahsilatlar" element={<Protected perm="tahsilat:read"><Tahsilatlar /></Protected>} />
            <Route path="/sevkiyat" element={<Protected perm="sevkiyat:read"><Sevkiyatlar /></Protected>} />
            <Route path="/satinalma" element={<Protected perm="satinalma:read"><SatinAlma /></Protected>} />
            <Route path="/alis-faturalari" element={<Protected perm="fatura:read"><AlisFaturalari /></Protected>} />
            <Route path="/tedarikci-odemeleri" element={<Protected perm="odeme:read"><TedarikciOdemeleri /></Protected>} />
            <Route path="/gunluk-ozet" element={<Protected perm="ozet:read"><GunlukOzet /></Protected>} />
            <Route path="/banka-hesaplari" element={<Protected perm="hesap:read"><BankaHesaplari /></Protected>} />
            <Route path="/finans/cekler" element={<Protected perm="tahsilat:read"><CekSenetler /></Protected>} />
            <Route path="/finans/senetler" element={<Protected perm="tahsilat:read"><CekSenetler /></Protected>} />
            <Route path="/finans/cek/:id" element={<Protected perm="tahsilat:read"><CekDetay /></Protected>} />
            <Route path="/finans/hesap/:id" element={<Protected perm="hesap:read"><HesapDetay /></Protected>} />
            <Route path="/finans/:tip" element={<Protected perm="hesap:read"><FinansHesaplar /></Protected>} />
            <Route path="/nakit-akis" element={<Protected perm="odeme:read"><NakitAkis /></Protected>} />
            <Route path="/banka-mutabakat" element={<Protected perm="hesap:read"><BankaMutabakat /></Protected>} />
            <Route path="/e-donusum" element={<Navigate to="/satis-faturalari" replace />} />
            <Route path="/satis-faturalari" element={<Protected perm="fatura:read"><EDonusum /></Protected>} />
            <Route path="/satis-faturalari/:id" element={<Protected perm="fatura:read"><SatisFaturaSayfa /></Protected>} />
            <Route path="/satis/teklifler" element={<Protected perm="siparis:read"><Teklifler /></Protected>} />
            <Route path="/satis/teklifler/:id" element={<Protected perm="siparis:read"><TeklifSayfa /></Protected>} />
            <Route path="/satis/tekrarli" element={<Protected perm="fatura:read"><TekrarliSatislar /></Protected>} />
            <Route path="/banka-hareketleri" element={<Protected perm="hesap:read"><BankaAkis /></Protected>} />
            <Route path="/toplu-aktarim" element={<Protected admin><Aktarim /></Protected>} />
            <Route path="/satici-paneli" element={<Protected><SaticiPaneli /></Protected>} />
            <Route path="/yardim" element={<Protected><Yardim /></Protected>} />
            <Route path="/giderler" element={<Protected perm="gider:read"><Giderler /></Protected>} />
            <Route path="/giderler/tipler" element={<Protected perm="gider:read"><GiderTipleri /></Protected>} />
            <Route path="/giderler/tekrarli" element={<Protected perm="gider:read"><TekrarliGiderler /></Protected>} />
            <Route path="/giderler/:id" element={<Protected perm="gider:read"><GiderDetay /></Protected>} />
            <Route path="/projeler" element={<Protected perm="proje:read"><Projeler /></Protected>} />
            <Route path="/projeler/:id" element={<Protected perm="proje:read"><ProjeDetay /></Protected>} />
            <Route path="/raporlar" element={<Protected><Raporlar /></Protected>} />
            <Route path="/ek-ozellikler" element={<Protected><Entegrasyonlar /></Protected>} />
            <Route path="/e-ticaret" element={<Protected><Entegrasyonlar /></Protected>} />
            <Route path="/abonelik" element={<Protected><Abonelik /></Protected>} />
            <Route path="/destek" element={<Protected><Destek /></Protected>} />
            <Route path="/destek/randevular" element={<Protected><Destek /></Protected>} />
            <Route path="/ayarlar/e-posta" element={<Protected><EPostaAyarlari /></Protected>} />
            <Route path="/lokasyonlar" element={<Protected><Lokasyonlar /></Protected>} />
            <Route path="/istasyonlar" element={<Protected><Istasyonlar /></Protected>} />
            <Route path="/ayarlar" element={<Protected admin><Ayarlar /></Protected>} />
            <Route path="/ayarlar/yazdirma-sablonlari" element={<Protected perm="sablon:write"><YazdirmaSablonlari /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <ModluToaster />
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
